module.exports = __webpack_public_path__ + "static/media/S1N3-2.528bcd07.svg";